import React from 'react';
import { ChannelMap } from '../../../../../redux/groups/api/group.model';
import ChannelSensor from './ChannelSensor';
import ChannelEvent from './ChannelEvent';
import ChannelAction from './ChannelAction';
import ChannelSetPoint from './ChannelSetPoint';
import ChannelVirtualSuperHeat from './ChannelVirtualSuperHeat';
import { ChannelVirtualSuperHeatProps } from './hooks/useChannelVirtualSuperHeat';
import { useNavigate } from 'react-router-dom';

export interface ChannelConnectionProps {
  channel: (ChannelMap & { name?: string }) | null;
  onClick?: () => void;
}
function ChannelConnection(
  props: ChannelConnectionProps & ChannelVirtualSuperHeatProps
) {
  const { channel } = props;
  const { channelType } = channel ?? {};

  const content =
    channelType === 'sensordata' ? (
      <ChannelSensor {...props} />
    ) : channelType === 'action' ? (
      <ChannelAction {...props} />
    ) : channelType === 'event' ? (
      <ChannelEvent {...props} />
    ) : channelType === 'setpoint' ? (
      <ChannelSetPoint {...props} />
    ) : channelType === 'virtual_superheat' ? (
      <ChannelVirtualSuperHeat {...props} />
    ) : (
      <p> not supported</p>
    );

  return content;
}
export default ChannelConnection;
